const DEFAULT_SORT_TYPE = 'asc';
const SORT_TYPES = {
  Ascending: 'asc',
  Descending: 'desc',
  None: 'none',
};

const PAGINATION_MODES = {
  Pages: 'pages',
  Records: 'records',
};
const DEFAULT_ROWS_PER_PAGE_DROPDOWN = [10, 20, 30, 40, 50];

export {
  DEFAULT_SORT_TYPE,
  SORT_TYPES,

  PAGINATION_MODES,
  DEFAULT_ROWS_PER_PAGE_DROPDOWN,
};
